import { render, staticRenderFns } from "./TokensManagerLandingPage.vue?vue&type=template&id=816fd9fe&"
import script from "./TokensManagerLandingPage.vue?vue&type=script&lang=js&"
export * from "./TokensManagerLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports